var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { colors, mq } from "core/styles/snippets";
import { config } from "core/utils";
import * as Option from "fp-ts/lib/Option";
import { TicketHightlight } from "pages/program/components/TicketHighlight";
import React from "react";
import styled from "styled-components";
function isCompatible(program) {
    return program.ticket !== null;
}
export var block = function (data) {
    if (!isCompatible(data))
        return Option.none;
    return Option.some({
        key: "programTicket",
        View: function () {
            var ref = useImpressionTracking({ id: data.ticket.uuid, name: data.ticket.title }, data.fetchingData);
            return (React.createElement(Container, { ref: ref },
                React.createElement(TicketHightlight, { data: data.ticket, trackingObject: {
                        list: config.tracking.listNames.ticketHighlight,
                        product: {
                            id: data.ticket.uuid,
                            name: data.ticket.title,
                            category: "ticket",
                        },
                    } })));
        },
    });
};
var Container = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 5rem 1.5rem;\n  background-color: ", " !important;\n\n  ", " {\n    padding: 5rem;\n  }\n"], ["\n  padding: 5rem 1.5rem;\n  background-color: ", " !important;\n\n  ", " {\n    padding: 5rem;\n  }\n"])), colors.white, mq.minWidth("64rem"));
var useImpressionTracking = function (info, skip) {
    var _a = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _a.ref, enteredViewport = _a.enteredViewport;
    if (skip || !enteredViewport)
        return ref;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "product_impression",
        ecommerce: {
            impressions: [
                __assign({ list: config.tracking.listNames.ticketHighlight }, info),
            ],
        },
    });
    return ref;
};
var templateObject_1;
